import { toThousandSeparator } from '@shared/innmaxLib/utils/webHelper'
import cx from 'classnames'
import { path } from 'ramda'
import React from 'react'
import { useTranslation } from 'react-i18next'
import MobileTable from './MobileTable'
import QueryTable from './QueryTable'
import { TableProps } from './table.type'

export { default as EditableTable } from './EditableTable'
export { EditableCell, EditableRow } from './EditableTableContext'
export { default as QueryTable } from './QueryTable'
export { default as ReportTable } from './ReportTable'
export { default as BaseTable } from './Table'

export type { RowAddHandler, RowDeleteHandler } from './EditableTable'
export type {
  EditableCellProps,
  EditableRowProps,
} from './EditableTableContext'

function TableFC<T = any>(props: TableProps<T>) {
  const [tableMode, setTableMode] = React.useState<'mobile' | 'desktop'>(
    'desktop'
  )

  React.useEffect(() => {
    const detectTableModel = () => {
      const breakPoints = 768
      if (window.innerWidth < breakPoints) {
        setTableMode('mobile')
      } else {
        setTableMode('desktop')
      }
    }
    detectTableModel()
    window.addEventListener('resize', detectTableModel)
    return () => {
      window.removeEventListener('resize', detectTableModel)
    }
  }, [])

  return tableMode === 'desktop' ? (
    <QueryTable {...props} />
  ) : (
    <MobileTable {...props} />
  )
}

const Table = React.memo(TableFC) as typeof TableFC

const RowCount = ({
  count = 0,
  className = '',
}: {
  count?: number
  className?: string
}) => {
  const { t } = useTranslation()
  return (
    <div className={cx('text-secondary text-sm', className)}>
      {t('common:total count', {
        total: toThousandSeparator(count),
      })}
    </div>
  )
}

const Sorter = (options: { sortField: string | string[] }) => {
  return {
    compare: (a: any, b: any) => {
      return (
        path<any>(
          Array.isArray(options.sortField)
            ? options.sortField
            : [options.sortField],
          a
        ) -
        path<any>(
          Array.isArray(options.sortField)
            ? options.sortField
            : [options.sortField],
          b
        )
      )
    },
  }
}

export default Object.assign(Table, {
  RowCount,
  Sorter,
})
